
(function(){


const sizeMap={
"Single":"90 x 190 cm",
"King Single":"107 x 200 cm",
"Small Double":"120 x 190 cm",
"Double":"135 x 190 cm",
"Queen":"150 x 200 cm",
"King":"150 x 200 cm",
"Super King":"180 x 200 cm"
};


function addSizeDimensions(){
document.querySelectorAll('.product .option-selector').forEach(optionBox=>{
const legend=optionBox.querySelector('legend');
if(!legend)return;

const optionName=legend.innerText.trim().toLowerCase();
if(!optionName.includes('size'))return;

optionBox.querySelectorAll('label.opt-label').forEach(label=>{
label.classList.add('custom-size-card');
if(label.querySelector('.size-dimension'))return;

const value=label.querySelector('.js-value')?.innerText.trim()||label.innerText.trim();
label.dataset.sizeValue=value;

if(!sizeMap[value])return;

const dimension=document.createElement('span');
dimension.className='size-dimension';
dimension.innerText=sizeMap[value];

label.appendChild(dimension);

});
});
}


function updateSizeLabel(){
document.querySelectorAll('.product .option-selector').forEach(optionBox=>{
const legend=optionBox.querySelector('legend');
if(!legend)return;

const optionName=legend.innerText.trim().toLowerCase();
if(!optionName.includes('size'))return;

const checked=optionBox.querySelector('.js-option:checked');
if(!checked)return;





let current=legend.querySelector('.js-size-current');

if(!current){

legend.innerHTML='';

const strong=document.createElement('strong');
strong.innerText='Size:';

legend.appendChild(strong);

legend.appendChild(document.createTextNode(' '));

current=document.createElement('span');
current.className='js-size-current';

legend.appendChild(current);

}



current.innerText=checked.value;

});
}


function init(){

const productType = ShopifyAnalytics.meta.product.type?.toLowerCase() || '';

const isMattress = productType.includes('mattress');


if(!isMattress){
return;
}


addSizeDimensions();

updateSizeLabel();


document.addEventListener('change',function(e){

if(e.target.matches('.js-option')){

updateSizeLabel();

}

});

}


if(document.readyState==='loading'){

document.addEventListener('DOMContentLoaded',init);

}else{

init();

}


})();